import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATION } from '@ngrx/router-store';
import { localizedMeta, MetaService } from '@planone/shared/util-meta';
import { combineLatestWith, tap } from 'rxjs';

import * as DataAccessExhibitorsPageActions from './data-access-exhibitors.page.actions';

import { DataAccessExhibitorsFacade } from '../../exhibitors/entity/data-access-exhibitors.facade';
import { DataAccessFairsFacade } from '../../fairs/entity/data-access-fairs.facade';

@Injectable()
export class DataAccessExhibitorsPageEffects {
  exhibitor_id?: string;

  routing$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        tap(() => {
          this.exhibitor_id = undefined;
        })
      ),
    { dispatch: false }
  );

  setTitle$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DataAccessExhibitorsPageActions.exhibitorsPageView),
        combineLatestWith(this.ExhibitorsFacade.exhibitor$, this.FairsFacade.isBauInsights$),
        tap(([_action, exhibitor, isBauInsights]) => {
          if (exhibitor) {
            if (isBauInsights) {
              this.metaService.setTitle(localizedMeta['titleCompanyDetails'], [exhibitor.name ?? '']);
            } else {
              this.metaService.setTitle(localizedMeta['titleExhibitorDetails'], [exhibitor.name ?? '']);
            }
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private ExhibitorsFacade: DataAccessExhibitorsFacade,
    private FairsFacade: DataAccessFairsFacade,
    private metaService: MetaService
  ) {}
}
